import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const vacantPostsService = {
  getAll,
  createOrUpdate,
  deletePost
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/vacant_posts/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newPost) {
  const requestOptions = {
    method: newPost.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newPost)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/vacant_posts${
    newPost.id ? `/${newPost.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(post) {
  let formData = new FormData();

  formData.append('vacant_post[title]', post.title);
  formData.append('vacant_post[date]', post.date);
  formData.append('vacant_post[description]', post.description);
  const document = post.document;

  if (document) {
    if (document.url) {
      formData.append(`vacant_post[document]`, document.url);
    } else {
      formData.append(`vacant_post[document]`, document, document.name);
    }
  }

  return formData;
}
function deletePost(postId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/vacant_posts/${postId}`;

  return axios.delete(url, requestOptionsDelete);
}
